import { createSelector } from '@reduxjs/toolkit'

export const selectRoles = createSelector(
  [state => state.adminPortalRoles],
  roles => roles.rolesList
)
